(function($) { "use strict";
window.customLocalStorage=
{
    getItem(key)
    {
        let result=JSON.parse(window.localStorage.getItem(key));

        if(result)
        {
 
            if(result.expireTime<=Date.now())
            {
                window.localStorage.removeItem(key);
                return null;
            }
            return result.data;
        }
        return null;
    },

    setItem(key, value, maxAge=30*30*60*1000)
    {
        let result=
        {
            data:value
        }

        if(maxAge)
        {
            result.expireTime=Date.now()+maxAge;
        }
        window.localStorage.setItem(key,JSON.stringify(result));
    },
    removeItem(key)
    {
        window.localStorage.removeItem(key);
    },
    clear()
    {
        window.localStorage.clear();
    }
}
$(document).ready(function(){
	"use strict";

	//Scroll back to top
	
	var progressPath = document.querySelector('.progress-wrap path');
	var pathLength = progressPath.getTotalLength();
	progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
	progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
	progressPath.style.strokeDashoffset = pathLength;
	progressPath.getBoundingClientRect();
	progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
	var updateProgress = function () {
		var scroll = $(window).scrollTop();
		var height = $(document).height() - $(window).height();
		var progress = pathLength - (scroll * pathLength / height);
		progressPath.style.strokeDashoffset = progress;
	}
	updateProgress();
	$(window).scroll(updateProgress);	
	var offset = 50;
	var duration = 550;
	jQuery(window).on('scroll', function() {
		if (jQuery(this).scrollTop() > offset) {
			jQuery('.progress-wrap').addClass('active-progress');
		} else {
			jQuery('.progress-wrap').removeClass('active-progress');
		}
	});				
	jQuery('.progress-wrap').on('click', function(event) {
		event.preventDefault();
		jQuery('html, body').animate({scrollTop: 0}, duration);
		return false;
	});
  
  var one_mint = 60000;
  var ps_expiry_days = 1;
  
  $('#Modalpop-up').on('hidden.bs.modal', function () {
    customLocalStorage.setItem('modalpop-up', 'hide', one_mint*60*24*ps_expiry_days);
  });

	
});
$('.gallery-slider').owlCarousel({
    loop:true,
    autoplay:true,
    margin:10,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:false,
            loop:true,
            autoplay:true
        },
        600:{
            items:2,
            nav:false,
            loop:true,
            autoplay:true
        },
        1000:{
            items:4,
            nav:false,
            loop:true,
            autoplay:true
        }
    }
});
  $('.winery-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
    autoplay:true,
    dots:true,
    responsiveClass:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
});   

// Function to add a class when scrolling down
function addClassOnScroll() {
  var scrollPosition = window.scrollY;

  // Replace '.your-element-selector' with the selector for the element you want to add the class to.
  var element = document.querySelector('.ernie-sticky-shop-banner');

  // Adjust the scroll position and class name as needed
  if (scrollPosition > 50) {
    element.classList.add('ernie-shop-banner-stick'); // Add your desired class name here
  } else {
    element.classList.remove('ernie-shop-banner-stick'); // Remove the class if scroll position is less than 200
  }
}

// Attach the function to the scroll event
window.addEventListener('scroll', addClassOnScroll);

function passwordtoogle(){
  const togglePassword = document.querySelector("#togglePassword");
        const password = document.querySelector("#password");

        togglePassword.addEventListener("click", function () {
            // toggle the type attribute
            const type = password.getAttribute("type") === "password" ? "text" : "password";
            password.setAttribute("type", type);
            
            // toggle the icon
            this.classList.toggle("fa-eye");
        });

        // prevent form submit
        // const form = document.querySelector("form");
        // form.addEventListener('submit', function (e) {
        //     e.preventDefault();
        // });
}passwordtoogle();

function passwordtoogle2(){
  const togglePassword = document.querySelector("#togglePassword2");
        const password = document.querySelector("#password2");

        togglePassword.addEventListener("click", function () {
            // toggle the type attribute
            const type = password.getAttribute("type") === "password" ? "text" : "password";
            password.setAttribute("type", type);
            
            // toggle the icon
            this.classList.toggle("fa-eye");
        });

        // prevent form submit
        // const form = document.querySelector("form");
        // form.addEventListener('submit', function (e) {
        //     e.preventDefault();
        // });
}passwordtoogle2();

     
})(jQuery); 


